var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelivered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: #6b21a8;\n      }\n\n      .st2, .st1 {\n        isolation: isolate;\n      }\n\n      .st3 {\n        stroke: #fff;\n      }\n\n      .st3, .st4 {\n        fill: #fff;\n      }\n\n      .st5 {\n        stroke: #d8b4fe;\n        stroke-width: 35px;\n      }\n\n      .st5, .st6 {\n        fill: none;\n        stroke-linecap: round;\n      }\n\n      .st4 {\n        stroke-width: 45px;\n      }\n\n      .st4, .st6 {\n        stroke: #6b21a8;\n      }\n\n      .st6 {\n        stroke-width: 8px;\n      }\n\n      .st1 {\n        font-family: Arial-BoldItalicMT, Arial;\n        font-size: 52px;\n        font-style: italic;\n        font-weight: 700;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "receipt"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 134.94,
    y: 81,
    width: 630,
    height: 830,
    rx: 60,
    ry: 60
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M374.94,146.44h150c13.81,0,25,11.19,25,25h0c0,13.81-11.19,25-25,25h-150c-13.81,0-25-11.19-25-25h0c0-13.81,11.19-25,25-25Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "content-lines"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 224.94,
    y1: 306,
    x2: 674.94,
    y2: 306
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 224.94,
    y1: 406,
    x2: 674.94,
    y2: 406
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 224.94,
    y1: 491,
    x2: 449.94,
    y2: 491
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 224.94,
    y1: 576,
    x2: 429.94,
    y2: 576
  })), /*#__PURE__*/React.createElement("g", {
    id: "signature"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 224.94,
    y1: 796,
    x2: 394.94,
    y2: 796
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(229.94 781)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SIGN")))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "package"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 525.1,
    y: 477,
    width: 400,
    height: 380,
    rx: 40,
    ry: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M660.1,477v135l65-45,65,45v-135"
  }), /*#__PURE__*/React.createElement("g", {
    id: "dots"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 775.1,
    y: 732,
    width: 40,
    height: 40,
    rx: 8,
    ry: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 825.1,
    y: 732,
    width: 40,
    height: 40,
    rx: 8,
    ry: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 774.18,
    y: 786.96,
    width: 40,
    height: 40,
    rx: 8,
    ry: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 825.1,
    y: 786.96,
    width: 40,
    height: 40,
    rx: 8,
    ry: 8
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M679.3,499.16v67.84l46.8-22.61,46.8,22.61v-67.84"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivered);
export default __webpack_public_path__ + "static/media/delivered.ec5c4ba4bbba7a7cdf7516db5823a7f1.svg";
export { ForwardRef as ReactComponent };